import WithdrawalForm from './WithdrawalForm.svelte';

export default new WithdrawalForm({
  target: document.getElementById('withdrawalform'),
});
